import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-white" data-id="element-75" data-mp="26lutcc89j2bx">
      <div className="mx-auto w-full max-w-content px-5 py-14 sm:px-8 sm:py-20" data-id="element-76" data-mp="26mw6qncr40wt">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-teal" data-id="element-77" data-mp="22m2fbk03o3z6">
          La trasformazione
        </p>
        <h2 className="mt-3 text-balance text-center font-display text-[30px] font-black leading-[1.1] tracking-[-0.02em] text-plum-deep sm:text-4xl" data-id="element-78" data-mp="2z8nwt2d1efpm">
          Prima e dopo il Progetto
        </h2>

        <div className="mt-9 grid gap-5 lg:grid-cols-2 lg:gap-6" data-id="element-79" data-mp="2qc6ijq9dm1pn">
          <div className="flex flex-col rounded-3xl bg-cream p-5 ring-1 ring-ink/10 sm:p-7" data-id="element-80" data-mp="2laqxhy777v79">
            <div className="flex items-center gap-2.5" data-id="element-81" data-mp="1evybpcmww486">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-ink/10" data-id="element-82" data-mp="19wdbkyw09ptv">
                <XIcon className="h-4 w-4 text-ink/50" aria-hidden="true" data-id="element-83" data-mp="175m3d1403acm" />
              </span>
              <h3 className="text-[13px] font-extrabold uppercase tracking-[0.16em] text-ink/50" data-id="element-84" data-mp="1c474d2r2ty24">
                Prima
              </h3>
            </div>
            <ul className="mt-5 space-y-3.5" data-id="element-85" data-mp="y461xiv5yikj">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-86" data-mp="1327m674bsnxl">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-ink/40" aria-hidden="true" data-id="element-87" data-mp="oecw6yhpcxo7" />
                  <span className="text-[15px] leading-snug text-ink/65 sm:text-base" data-id="element-88" data-mp="t64n5a4rt5ev">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col rounded-3xl bg-plum p-5 sm:p-7" data-id="element-89" data-mp="fcd9pqnx51dv">
            <div className="flex items-center gap-2.5" data-id="element-90" data-mp="jgb7ny1ic65c">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gold" data-id="element-91" data-mp="5fh17ky0sf9b">
                <CheckIcon className="h-4 w-4 text-plum-deep" aria-hidden="true" data-id="element-92" data-mp="afmwdb3i0jw5" />
              </span>
              <h3 className="text-[13px] font-extrabold uppercase leading-tight tracking-[0.14em] text-white" data-id="element-93" data-mp="2c4sti75hjvz1">
                Dopo il Progetto
              </h3>
            </div>
            <ul className="mt-5 space-y-3.5" data-id="element-94" data-mp="23byyn1dk2o02">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-95" data-mp="239l732i33tx9">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-96" data-mp="1yefghqdqlr2u" />
                  <span className="text-[15px] font-medium leading-snug text-white sm:text-base" data-id="element-97" data-mp="2v2ljk8v0gbf0">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-98" data-mp="2m49wggtcrvrb">
          <CTAButton label="Voglio la versione “dopo” della mia pratica" sub="Accesso immediato per 19 €" variant="plum" data-id="element-99" data-mp="2h2ath81iz0uw" />
        </div>
      </div>
    </section>;
}